import { render } from "./FemaleBack.vue?vue&type=template&id=3650ac66"
import script from "./FemaleBack.vue?vue&type=script&lang=js"
export * from "./FemaleBack.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/medsien-patient-app/medsien-patient-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__